import { render, staticRenderFns } from "./SingleSliderFilter.vue?vue&type=template&id=65000c2a&scoped=true"
import script from "./SingleSliderFilter.vue?vue&type=script&setup=true&lang=ts"
export * from "./SingleSliderFilter.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SingleSliderFilter.vue?vue&type=style&index=0&id=65000c2a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65000c2a",
  null
  
)

export default component.exports